import script from "./UIMiniMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIMiniMap.vue?vue&type=script&lang=ts&setup=true"

import "./UIMiniMap.vue?vue&type=style&index=0&id=343550b1&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343550b1"]])

export default __exports__